import React from "react";
import RIcon from "../../reservas/components/ReservasIcons";

export const DESKTOP_STEPS = ["Servicios", "Elegir turno", "Tus datos", "Pago"];

/** Desktop step indicator: the exact Canchas `.steps` markup with the beauty step labels. */
const StepIndicator = ({ current }) => (
  <div className="steps" aria-label="Pasos de la reserva">
    {DESKTOP_STEPS.map((label, index) => {
      const number = index + 1;
      const state = number < current ? "done" : number === current ? "on" : "";
      return (
        <React.Fragment key={label}>
          {index > 0 && <div className={`step-sep${number <= current ? " done" : ""}`} />}
          <div className={`step ${state}`.trim()} aria-current={number === current ? "step" : undefined}>
            <span className="dot">
              {state === "done" ? <RIcon name="check" width={13} height={13} /> : number}
            </span>
            {label}
          </div>
        </React.Fragment>
      );
    })}
  </div>
);

export default StepIndicator;
